import { render, staticRenderFns } from "./AddRoles.vue?vue&type=template&id=cf0c2596&scoped=true&"
import script from "./AddRoles.vue?vue&type=script&lang=js&"
export * from "./AddRoles.vue?vue&type=script&lang=js&"
import style0 from "./AddRoles.vue?vue&type=style&index=0&id=cf0c2596&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0c2596",
  null
  
)

export default component.exports